import {
  connectTradeNotifications,
  type TradeNotificationsProps,
} from 'components/common-form/sidePanel/actions/trade/tradeNotifications.connect';
import { IcMultiplePicker } from 'components/shared/IcPicker/IcMultiplePicker';
import { FC } from 'react';

const RawNotifications: FC<TradeNotificationsProps> = ({ contactIds, tabId, onContactIdsChanged }) => {
  return (
    <div className="card border-start my-3">
      <div className="card-body ps-3 pe-0 py-0">
        <IcMultiplePicker
          withLabel
          id={`${tabId}-trade-ic-picker`}
          labelTranslationKey="icMultiplePicker.tradeNotifications.title"
          placeholderTranslationKey="icMultiplePicker.tradeNotifications.placeholder"
          selectedIds={contactIds}
          onChange={c => onContactIdsChanged(c.map(contact => contact.id))}
        />
      </div>
    </div>
  );
};

export const TradeNotifications = connectTradeNotifications(RawNotifications);
RawNotifications.displayName = 'TradeNotifications';
